<script lang="ts">
	import { initClient } from '@urql/svelte'
	import { Router, Link, Route } from 'svelte-routing'
	import Wallet from './Components/Wallet.svelte'

	export let url = "";

</script>

<main>
	<Router url="{url}">
	<nav>
		<Wallet />
	</nav>
	<Route path="/">

	</Route>
	</Router>
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}
	nav {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>